export default __webpack_public_path__ + "static/beanBeatz-9b184d03171269ae9a354344bb556cd8.mp3";